/* eslint-disable no-unused-vars */
import ApiFetch from 'utils/apiFetch';
import { CMS_API_URL } from 'constants/apiConf';

// CMS config is shared with the native app; skip the PORTAL origin so the web
// reads the same values (WEB_MLS-779).
const ApiFetchInstance = ApiFetch(CMS_API_URL, { skipOrigin: true });

export const URLS = {
  globalConfiguration: 'cms/global_configurations',
};

export default {
  getGlobalConfiguration() {
    return ApiFetchInstance.get(URLS.globalConfiguration);
  },
};
